import { OrderInfo, OrderItemInfo, ItemOptionInfo } from "../models/models";
import { Ticket } from "../models/RestModels";
import { Utils } from "./Utils";

export class TicketBuilder {

	private order_info: OrderInfo;
	private ticket: Ticket;
	private qty_col_width: number = 0;
	private price_col_width: number = 0;
	private total_col_width: number = 0;
	private qty2_col_width: number = 0;
	private qty_times_price_col_width: number = 0;
	private subtotal_col_width: number = 0;

	private show_qty_col: boolean;
	private show_price_col: boolean;
	private show_total_col: boolean;
	private show_options: boolean;
	private show_qty2_col: boolean;
	private show_qty_times_price_col: boolean;
	private show_subtotal_col: boolean;
    font_row: string = 'b';

    ticket_a_columns: number = 32; // for 56mm printers
	ticket_b_columns: number = 42; // for 54mm printers

    // ticket_a_columns: number = 48; // for 80mm printers
	// ticket_b_columns: number = 56; // for 80mm printers

	//Default for 80mm printers
	constructor(order_info: OrderInfo, ticket: Ticket = null, ticket_a_columns:number = 48, ticket_b_columns:number = 56)
	{
		this.order_info = order_info;
		this.ticket = ticket || this.defaulticket();

		this.show_qty_col = this.ticket.item_qty1_display !== 'NEVER';
		this.show_price_col = this.ticket.item_price_display !== 'NEVER';
		this.show_total_col = true;
		this.show_options = this.ticket.option_row_display !== 'NEVER';
		this.show_qty2_col = this.ticket.item_qty2_display !== 'NEVER';
		this.show_qty_times_price_col = this.ticket.item_qty_times_price_display !== 'NEVER';
		this.show_subtotal_col = this.ticket.item_subtotal_display !== 'NEVER';
		this.ticket_a_columns = ticket_a_columns;
		this.ticket_a_columns = ticket_b_columns;
	}

	private getEncoderMaxColumns(font_name:'a' | 'b' = 'b'): number
	{
		return font_name == 'a' ? this.ticket_a_columns : this.ticket_b_columns;
	}

	public buildXml(): string {
		this.calculateColumnWidths();
		let xml = '<EscPos>\n';
		xml += '<Init/>'
		xml += this.buildHeader();
		xml += this.buildItemsTable();
		xml += this.buildFooter();
		xml += '</EscPos>';
		return xml;
	}

	public defaulticket():Ticket
	{
		return {
			id: 0,
			created: new Date(),
			created_by_user_id: 0,
			exceptions_display: 'ONLY_IF_PRESENT',
			footer: '',
			header: '',
			item_money_sign_display: 'ONLY_IF_HAS_PRICE',
			item_name_display: 'TRUNCATED',
			item_note_display: 'ALWAYS',
			item_price_display:'ONLY_IF_HAS_PRICE',
			item_qty1_display: 'NEVER',
			item_qty2_display: 'NEVER',
			item_qty_times_price_display: 'ONLY_IF_HAS_PRICE',
			item_subtotal_display: 'NEVER',
			item_total_display: 'ONLY_IF_HAS_PRICE',
			name: '',
			option_item_display: 'ALWAYS',
			option_price_display: 'ONLY_IF_HAS_PRICE',
			option_qty_by_item: 'ALWAYS',
			option_row_display: 'ALWAYS',
			option_total_qty: 'ONLY_IF_HAS_PRICE',
			option_total_qty_times_price:'ONLY_IF_HAS_PRICE',
			order_note_display: 'ALWAYS',
			updated: new Date(),
			updated_by_user_id: 0,
		};
	}

	private calculateColumnWidths() {
		if (this.show_qty_col) {
			for (const item of this.order_info.items) {
				this.qty_col_width = Math.max(this.qty_col_width, item.order_item.qty.toString().length);
			}
			this.qty_col_width += 1;
		}

		if (this.show_qty2_col) {
			for (const item of this.order_info.items) {
				this.qty2_col_width = Math.max(this.qty2_col_width, item.order_item.qty.toString().length);
			}
			this.qty2_col_width += 1;
		}

		if (this.show_price_col)
		{
			for (const order_item_info of this.order_info.items)
			{
				if(order_item_info.order_item.item_option_id )
				{
					//This is a item_option
					if( this.show_options )
					{
						this.price_col_width = Math.max(this.price_col_width, Utils.formatMoney(order_item_info.order_item.unitary_price).length);
					}
				}
				else
				{
					//Normal item
					this.price_col_width = Math.max(this.price_col_width, Utils.formatMoney(order_item_info.order_item.unitary_price).length);
				}
			}


			this.price_col_width += 1;
		}

		if (this.show_qty_times_price_col) {
			for (const item of this.order_info.items) {

				if( item.order_item.item_option_id )
				{
					if( this.show_options )
					{
						const qty_times_price = item.order_item.qty+'×'+Utils.formatMoney(item.order_item.unitary_price);
						this.qty_times_price_col_width = Math.max(this.qty_times_price_col_width, qty_times_price.length);
					}
				}
				else
				{
					const qty_times_price = item.order_item.qty+'×'+Utils.formatMoney(item.order_item.unitary_price);
					this.qty_times_price_col_width = Math.max(this.qty_times_price_col_width, qty_times_price.length);
				}
			}

			this.qty_times_price_col_width += 1;
		}

		if (this.show_subtotal_col)
		{
			for (const item of this.order_info.items) {
				if( item.order_item.item_option_id )
				{
					if( this.show_options )
					{
						this.subtotal_col_width = Math.max(this.subtotal_col_width, Utils.formatMoney(item.order_item.subtotal).length);
					}
				}
				else
				{
					this.subtotal_col_width = Math.max(this.subtotal_col_width, Utils.formatMoney(item.order_item.subtotal).length);
				}
			}
			this.subtotal_col_width += 1;
		}

		if (this.show_total_col) {
			for (const item of this.order_info.items) {
				this.total_col_width = Math.max(this.total_col_width, Utils.formatMoney(item.order_item.total).length);
			}
			this.total_col_width += 1;
		}
	}

	private buildHeader(): string {
		if (this.ticket.header) {
			return `<Text justification="center">${this.ticket.header}</Text>\n`;
		}
		return '';
	}

	private buildItemsTable(): string {

		let tableXml = '';
		tableXml += '<Table font="b">\n';
		tableXml += this.buildItemsTableColumns();
		tableXml += this.buildItemsTableRows();
		tableXml += '</Table>\n';
		return tableXml;
	}

	private buildItemsTableColumns(): string {
		let columnsXml = '<Columns>\n';

		let remaining_width = this.getEncoderMaxColumns('b');

		if (this.show_qty_col) {
			columnsXml += `<Column width="${this.qty_col_width}" align="left" marginRight="1" />\n`;
			remaining_width -= this.qty_col_width + 1;
		}

		let item_name_width = remaining_width;

		if (this.show_qty2_col) {
			item_name_width -= this.qty2_col_width + 1;
		}

		if (this.show_price_col) {
			item_name_width -= this.price_col_width + 1;
		}

		if (this.show_qty_times_price_col) {
			item_name_width -= this.qty_times_price_col_width + 1;
		}

		if (this.show_subtotal_col) {
			item_name_width -= this.subtotal_col_width + 1;
		}

		if (this.show_total_col) {
			item_name_width -= this.total_col_width+1;
		}

		columnsXml += `<Column width="${item_name_width}" align="left" marginRight="1" />\n`;

		if (this.show_qty2_col) {
			columnsXml += `<Column width="${this.qty2_col_width}" align="left" marginRight="1" />\n`;
		}

		if (this.show_price_col) {
			columnsXml += `<Column width="${this.price_col_width}" align="right" marginRight="1" />\n`;
		}

		if (this.show_qty_times_price_col) {
			columnsXml += `<Column width="${this.qty_times_price_col_width}" align="right" marginRight="1" />\n`;
		}

		if (this.show_subtotal_col) {
			columnsXml += `<Column width="${this.subtotal_col_width}" align="right" marginRight="1" />\n`;
		}

		if (this.show_total_col) {
			columnsXml += `<Column width="${this.total_col_width}" align="right" />\n`;
		}

		columnsXml += '</Columns>\n';
		return columnsXml;
	}

	private buildHeaderRow(): string {
		let rowXml = '<Row>\n';
		if (this.show_qty_col) {
			rowXml += '<Cell><Text>Cant</Text></Cell>\n';
		}
		rowXml += '<Cell><Text>Articulo</Text></Cell>\n'; // For

		if (this.show_qty2_col) {
			rowXml += '<Cell><Text>Cant</Text></Cell>\n';
		}
		if (this.show_price_col) {
			rowXml += '<Cell><Text>$</Text></Cell>\n';
		}
		if (this.show_qty_times_price_col) {
			rowXml += '<Cell><Text>Cant×Prec</Text></Cell>';
		}
		if (this.show_subtotal_col) {
			rowXml += '<Cell><Text>Sub</Text></Cell>\n';
		}
		if (this.show_total_col) {
			rowXml += '<Cell><Text>Total</Text></Cell>\n';
		}
		rowXml += '</Row>\n';
		return rowXml;
	}

	private buildItemsTableRows(): string {
		let rowsXml = '<Rows>\n';
		rowsXml += this.buildHeaderRow();

		for (const item of this.order_info.items) {
			rowsXml += this.buildItemRow(item);
			if (this.show_options && item.options.length > 0) {
				rowsXml += this.buildItemOptionRows(item);
			}
			if (item.order_item.has_separator === 'YES') {
				rowsXml += this.buildSeparatorRow();
			}
		}
		rowsXml += '</Rows>\n';
		return rowsXml;
	}

	buildItemOptionRows(item: OrderItemInfo) {
		throw new Error("Method not implemented.");
	}

	private buildSeparatorRow(): string {
		let rowXml = '<Row>\n';
		if (this.show_qty_col) {
			rowXml += '<Cell><Rule/></Cell>\n';
		}
		rowXml += '<Cell><Rule/></Cell>\n'; // For the item name column
		if (this.show_qty2_col) {
			rowXml += '<Cell><Rule/></Cell>\n';
		}
		if (this.show_price_col) {
			rowXml += '<Cell><Rule/></Cell>\n';
		}
		if (this.show_qty_times_price_col) {
			rowXml += '<Cell><Rule/></Cell>\n';
		}
		if (this.show_subtotal_col) {
			rowXml += '<Cell><Rule/></Cell>\n';
		}
		if (this.show_total_col) {
			rowXml += '<Cell><Rule/></Cell>\n';
		}
		rowXml += '</Row>\n';
		return rowXml;
	}

	private buildRow(qty: string, name: string, qty2: string, price: string, qty_times_price: string, subtotal: string, total: string): string {
		let rowXml = '<Row>\n';
		if (this.show_qty_col) {
			rowXml += `<Cell><Text font="${this.font_row}">${qty}</Text></Cell>\n`;
		}

		let name_str = name.replaceAll('&','&amp;').replaceAll('>','&gt;').replaceAll('<','&lt');

		rowXml += `<Cell><Text>${name}</Text></Cell>\n`;
		if (this.show_qty2_col) {
			rowXml += `<Cell><Text>${qty2}</Text></Cell>\n`;
		}
		if (this.show_price_col) {
			rowXml += `<Cell><Text>${price}</Text></Cell>\n`;
		}
		if (this.show_qty_times_price_col) {
			rowXml += `<Cell><Text>${qty_times_price}</Text></Cell>\n`;
		}
		if (this.show_subtotal_col) {
			rowXml += `<Cell><Text>${subtotal}</Text></Cell>\n`;
		}
		if (this.show_total_col) {
			rowXml += `<Cell><Text>${total}</Text></Cell>\n`;
		}
		rowXml += '</Row>\n';
		return rowXml;
	}

	private buildItemRow(order_item_info: OrderItemInfo): string {
		const qty = order_item_info.order_item.qty.toString();
		const qty2 = this.show_qty2_col ? qty : '';
		const name = order_item_info.item.name;
		const price = Utils.formatMoney(order_item_info.order_item.unitary_price);
		const qty_times_price = Utils.formatMoney(order_item_info.order_item.qty * order_item_info.order_item.unitary_price);
		const subtotal = Utils.formatMoney(order_item_info.order_item.subtotal);
		const total = order_item_info.order_item.total > 0 ? Utils.formatMoney(order_item_info.order_item.total) : '';
		return this.buildRow(qty, name, qty2, price, qty_times_price, subtotal, total);
	}

	private buildFooter(): string {
		if (this.ticket.footer) {
			return `<Text justification="center">${this.ticket.footer}</Text>\n`;
		}
		return '';
	}
}
